import api from "@wallet-manager/node-types/dist/src/access/APIEndpoints/index";
import axios from "./axiosInstance";

const { EPtAssetManagement } = api;

export async function getPendingSummary(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    EPtAssetManagement.EndPtWalletApproveAllowanceRequest.getPendingSummary,
    input,
  );
}
